// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2lssG","rootSuccess":"CompleteLink_rootSuccess__2hMYt","rootFailure":"CompleteLink_rootFailure__90C16","isDisabled":"CompleteLink_isDisabled__2Gktr"};